import React from 'react';
import { InputNumber, Select, Space, Typography } from 'antd';

const { Text } = Typography;

export const vocabOptions = (entries) => (entries || []).map((e) => ({ value: e.id, label: e.label }));

/**
 * Editor for a weighted facet family ({id, weight}[]): a multi-select of
 * vocab ids plus a 0-1 weight input per selected value (weights feed
 * ranking/matching). Used by the ingestion Step3 review UI and the catalog
 * item editor.
 */
export const WeightedFacetEditor = ({ label, options, value, onChange, defaultWeight = 1, size }) => (
    <div>
        {label && (
            <Text type="secondary" style={{ fontSize: 12 }}>
                {label}
            </Text>
        )}
        <Select
            mode="multiple"
            size={size}
            style={{ width: '100%' }}
            placeholder={label || 'Select'}
            value={(value || []).map((e) => e.id)}
            onChange={(ids) =>
                onChange(ids.map((id) => (value || []).find((e) => e.id === id) || { id, weight: defaultWeight }))
            }
            options={options}
            optionFilterProp="label"
        />
        {(value || []).length > 0 && (
            <Space wrap style={{ marginTop: 4 }}>
                {(value || []).map((e) => (
                    <InputNumber
                        key={e.id}
                        size="small"
                        addonBefore={e.id}
                        min={0}
                        max={1}
                        step={0.05}
                        value={e.weight}
                        onChange={(w) =>
                            onChange((value || []).map((x) => (x.id === e.id ? { ...x, weight: w ?? 0 } : x)))
                        }
                    />
                ))}
            </Space>
        )}
    </div>
);
